import axios from './axios'

export async function sendMailForgotPassword(userDetails) {
    const response = await axios.post(`api/password/email`, userDetails);
     return response.data
}

export async function checkCodeForgotPassword(userDetails) {
    const response = await axios.post(`api/password/code/check`, userDetails);
     return response.data
}

export async function resetPassword(userDetails) {
    const response = await axios.post(`api/password/reset`, userDetails);
     return response.data
}

export async function checkAuthentication(userDetails) {
    const response = await axios.post(`api/user/login`, userDetails)
     return response.data
}

export async function checkAuthenticationLaravel(userDetails) {
    const response = await axios.post(`/loginVf`, userDetails);
     return response.data
}


export async function checkAuthenticationOAuth(userDetails) {
    const response = await axios.post(`api/user/loginOAuth`, userDetails);
     return response.data
}